import {getGregorianFormat, getHijriFormat} from "../../helpers/general-functions";

export default function Footer() {
    return (
        <p className="font-semibold text-sm text-pol-purple-2 text-center xl:text-start mt-5 xl:mt-0">© {getHijriFormat("", "YYYY")} - {getGregorianFormat("", "YYYY")}  |  تمام حقوق وب سایت برای استارت‌آپ <a rel="noopener noreferrer" target="_blank" href={process.env.REACT_APP_MAIN_URL} className="text-pol-main-purple">پل دیزاینرز</a> محفوظ است.</p>
    )
}
